import React from 'react';
import { overlays, actions } from '@ecosystem/newron-design-system';
import { CustomSegmentType } from '../types';

const { Modal } = overlays;
const { Button } = actions;

type props = {
  /**The header of the modal */
  header: string;
  /** The text description that in the modal*/
  infoText: string;
  /**the subtext of the modal */
  subText: string;
  /** is the modal open or not */
  isOpen: boolean;
  /**modal type - used for data test id*/
  customClassModalType: CustomSegmentType;
  /** callback function for deleting */
  onDelete: () => void;
  /** callback function for closing the modal */
  onClose: () => void;
};

/**
 * The modal component that is shown when the user press "Delete"
 */
export const DeleteSavedCustomModal = ({
  header,
  infoText,
  subText,
  isOpen,
  customClassModalType,
  onDelete,
  onClose,
}: props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>
        <div className="text-2xl">{header}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4 text-xl">{infoText}</div>
        <div className="mb-2 text-lg text-inactive">{subText}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} mode="secondary" testId={`close-${customClassModalType}-modal-btn`}>
          Cancel
        </Button>
        <Button onClick={onDelete} isDanger={true} testId={`delete-${customClassModalType}-modal-btn`}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
